module.exports = __webpack_public_path__ + "static/child-356bbbbc447bc0f69a6c00d188b54223.png";